import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";

type BtnProps = ButtonHTMLAttributes<HTMLButtonElement> & { tone?: "primary" | "default" | "ghost" | "danger" };

export function Btn({ tone = "default", className, type = "button", ...rest }: BtnProps) {
  return (
    <button
      type={type}
      {...rest}
      className={clsx(
        "inline-flex h-8 items-center justify-center gap-1.5 rounded-[var(--radius-ui)] px-3 text-[12.5px] whitespace-nowrap transition-colors disabled:cursor-not-allowed disabled:opacity-50",
        tone === "primary" && "bg-accent font-medium text-bg hover:opacity-90",
        tone === "default" && "border border-border bg-bg hover:border-border-strong hover:bg-bg-hover",
        tone === "ghost" && "text-fg-muted hover:bg-bg-hover hover:text-fg",
        tone === "danger" && "border border-border text-err hover:bg-err-bg",
        className,
      )}
    />
  );
}
